<template>
  <div>
    <playlist-card v-for="playlist in playlists"
        :key="playlist.id"
        :playlist="playlist"
        :inArtistProfile="inArtistProfile"
        :section="section">
    </playlist-card>
  </div>
</template>

<script>
import PlaylistCard from './PlaylistCard.vue'
export default {
  name: 'playlist-list',
  components: {
    PlaylistCard
  },
  props: {
    playlists: {
      required: true
    },
    inArtistProfile: {
      default: false
    },
    section: {
      default: ''
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/playlists/PlaylistList.vue